import React, { FC } from "react";
import { PATHNAMES } from "src/constants/routes";
import logoWhiteImage from "src/assets/images/logo-white.png";
import logoColorImage from "src/assets/images/logo-colored.png";
import { Link } from "../Link";

const LOGO_IMAGE_ALT_TEXT = "Bussiness Clone";

interface Props {
  className?: string;
  isColored?: boolean;
}

export const Logo: FC<Props> = ({ isColored = false, className }) => (
  <div className={className}>
    <Link href={PATHNAMES.HOME}>
      <img
        className="w-40.5 h-9"
        src={isColored ? logoColorImage : logoWhiteImage}
        alt={LOGO_IMAGE_ALT_TEXT}
      />
    </Link>
  </div>
);
